import { useParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";

export function resolveQuestion(question, answers = []) {
  if (!question?.answerVariants) return question;

  const { fromQuestion, variants } = question.answerVariants;
  const previousIdent = answers.find(
    (answer) => answer.question_ident === fromQuestion,
  )?.answer_ident;

  const resolvedAnswers =
    variants?.[previousIdent] ||
    variants?.default ||
    question.answers ||
    [];

  return {
    ...question,
    answers: resolvedAnswers,
  };
}

export function resolveGameData(gameData, answers = []) {
  if (!gameData?.content) return gameData;

  return {
    ...gameData,
    content: gameData.content.map((question) =>
      resolveQuestion(question, answers),
    ),
  };
}

export function useResolvedGameData(answers) {
  const { ident } = useParams();
  const queryClient = useQueryClient();

  return resolveGameData(
    queryClient.getQueryData(["game-questions", ident]),
    answers,
  );
}
